import { createSlice } from '@reduxjs/toolkit'

export const initialState = {
  groupList: [],
}
const groupSlice = createSlice({
  name: 'dataGroups',
  initialState,
  reducers: {
    getAllGroups(state, action) {
      return { ...state, groupList: action.payload.data }
    },
    clearGroups(state, action) {
      return { ...state, groupList: [] }
    },
  },
})

export default groupSlice
